import React from 'react';
// @ts-ignore
import DatePicker, { registerLocale } from 'react-datepicker';
import nb from 'date-fns/locale/nb';
import classnames from 'classnames';

registerLocale("nb", nb);

export interface ICheckoutDeliveryDateComponentProps {
    leadText: string;
    onDateChanged(date: Date): Promise<void>;
    selectedDate: Date
    filterDates(date: Date): boolean;
    enabled: boolean;
    working: boolean;
}

const DlvryCheckoutDeliveryDateComponent: React.FC<ICheckoutDeliveryDateComponentProps> = ({
    leadText,
    onDateChanged,
    selectedDate,
    filterDates,
    enabled,
    working
}) => {
    filterDates = (filterDates) || ((date: Date): boolean => false);
    onDateChanged = (onDateChanged) || ((date: Date): Promise<void> => Promise.resolve());

    const baseClassName = 'ms-checkout-delivery-options__deliverydate';
    const sharedProps = {
        locale: 'nb',
        dateFormat: 'dd.MM.yyyy',
        selected: selectedDate,
        disabled: working || !enabled,
        showIcon: true
    };

    return (
        <div className={classnames(baseClassName, {
            [`${baseClassName}__disabled`]: !enabled
        })}>
            <span className={`${baseClassName}__label`}>{leadText}</span>
            {enabled ? (
                <DatePicker
                    {...sharedProps}
                    filterDate={filterDates}
                    onChange={(date: Date) => onDateChanged(date)}
                    disabledKeyboardNavigation
                    popperModifiers={[
                        {
                            name: 'arrow',
                            options: {
                                padding: 6 // 6px from the edges of the popper
                            }
                        }
                    ]}
                />
            ) : (
                <DatePicker
                    {...sharedProps}
                />
            )}
            <span className={`${baseClassName}__spinner${working ? ' working' : ''}`}></span>
            <br style={{ display: 'none' }} />
        </div>
    );
};

export default DlvryCheckoutDeliveryDateComponent;
